export enum EnrollmentType {
    FormEnrollment = 'FormEnrollment',
    ReviewEnrollment = 'ReviewEnrollment',
    EventEnrollment = 'EventEnrollment',
    ConsultationEnrollment = 'ConsultationEnrollment',
    SecurityDepositEnrollment = 'SecurityDepositEnrollment',
    InvoiceEnrollment = 'InvoiceEnrollment',
    AppointmentEnrollment = 'AppointmentEnrollment',
}
